import { Flex, Popconfirm, Tag, Tooltip } from 'antd';
import { AuthorizedIcon, Icon } from '../../../components';
import TrashSolidBlack from '../../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../../assets/icons/pen-to-square-solid-w-black.svg';
import EyeRegularWBlack from '../../../assets/icons/eye-regular-w-black.svg';
import Variant99Black from '../../../assets/icons/variant99-black.svg';
import FolderOpenRegular from '../../../assets/icons/folder-open-regular.svg';
import styles from './index.module.scss';
import { status_colors } from '../../../assets/conts';
import { IEnum } from '../../../services/type';
import { getValueFromEnum } from '../../../utils/functions';
import { ColumnType } from 'antd/es/table';
import { actionTypes } from '../../../assets/enums';
import {
  IFile,
  IOrganization,
  ITravelHealthInsuranceDataSource,
} from '../../../types';

export const getColumns = (
  handleClickEye: (id: number) => void,
  handleOpenEditModal: (id: number) => void,
  handleClickDelete: (id: number) => Promise<void>,
  handleClickCancel: (id: number) => Promise<void>,
  handleSetAdditionalFile: (id: number, file: IFile[]) => void,
  organizations: IOrganization[],
  statusChoices: IEnum[],
  policyTypes: IEnum[],
  countries: IEnum[],
  travelHealthInsurancePolicyTypes: IEnum[],
): Array<
  ColumnType<ITravelHealthInsuranceDataSource> & { searchable?: boolean }
> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    searchable: true,
    width: 125,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'İsim',
    dataIndex: 'first_name',
    key: 'first_name',
    width: 150,
    searchable: true,
    sorter: (a, b) => a.first_name?.localeCompare(b.first_name),
  },
  {
    title: 'Soyisim',
    dataIndex: 'last_name',
    key: 'last_name',
    width: 150,
    searchable: true,
    sorter: (a, b) => a.last_name?.localeCompare(b.last_name),
  },
  {
    title: 'Poliçe No',
    dataIndex: 'policy_number',
    key: 'policy_number',
    width: 150,
    searchable: true,
    sorter: (a, b) => a.policy_number?.localeCompare(b.policy_number),
  },
  {
    title: 'Poliçe Tipi',
    dataIndex: 'type',
    key: 'type',
    width: 150,
    sorter: (a, b) => a.type?.localeCompare(b.type),
    render: (_: unknown, record: ITravelHealthInsuranceDataSource) => (
      <Tag className={styles[`${record.type}Tag`]}>
        {getValueFromEnum(travelHealthInsurancePolicyTypes, record.type)}
      </Tag>
    ),
  },
  {
    title: 'Poliçe Başlangıç Tarihi',
    dataIndex: 'start_date',
    key: 'start_date',
    width: 200,
    sorter: true,
  },
  {
    title: 'Poliçe Bitiş Tarihi',
    dataIndex: 'end_date',
    key: 'end_date',
    width: 175,
    sorter: true,
  },
  {
    title: 'Seyahat Başlangıç Tarihi',
    dataIndex: 'travel_start_date',
    key: 'travel_start_date',
    width: 225,
    sorter: (a, b) => a.travel_start_date?.localeCompare(b.travel_start_date),
  },
  {
    title: 'Seyahat Bitiş Tarihi',
    dataIndex: 'travel_end_date',
    key: 'travel_end_date',
    width: 200,
    sorter: (a, b) => a.travel_end_date?.localeCompare(b.travel_end_date),
  },
  {
    title: 'Ülke',
    dataIndex: 'countries',
    key: 'countries',
    width: 150,
    sorter: (a, b) => a.countries.join('')?.localeCompare(b.countries.join('')),
    render: (_: unknown, record: ITravelHealthInsuranceDataSource) => (
      <Tooltip
        title={record.countries
          .map(
            (key: string) =>
              countries.find((country) => country.key === key)?.value,
          )
          .join(', ')}
      >
        <span>{`${record.countries
          .map(
            (key: string) =>
              countries.find((country) => country.key === key)?.value,
          )
          .join(', ')
          .slice(0, 20)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Durum',
    dataIndex: 'recent_status',
    key: 'recent_status',
    width: 150,
    filters: statusChoices.map((item) => ({
      text: getValueFromEnum(statusChoices, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    render: (_: unknown, record: ITravelHealthInsuranceDataSource) => (
      <Tag color={status_colors[record.recent_status]}>
        {getValueFromEnum(statusChoices, record.recent_status)}
      </Tag>
    ),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 160,
    render: (_: unknown, record: ITravelHealthInsuranceDataSource) => (
      <Flex justify="flex-end" gap={14}>
        <Icon
          source={EyeRegularWBlack}
          popoverText={actionTypes.VIEW}
          onClick={() => record?.id && handleClickEye(record.id)}
        />
        {record.recent_status !== 'cancelled' && (
          <Popconfirm
            title={
              <div className={styles.popconfirmTitle}>
                İptal işlemini onaylıyor musunuz?
              </div>
            }
            overlayInnerStyle={{
              width: 150,
              borderColor: '#D6222A',
              borderWidth: 1,
              borderStyle: 'solid',
            }}
            okText="Onayla"
            cancelText="İptal"
            icon={null}
            color="#FAFAFA"
            okButtonProps={{ danger: true, style: { width: '45%' } }}
            cancelButtonProps={{ danger: true, style: { width: '45%' } }}
            onConfirm={() => record.id && handleClickCancel(record.id)}
          >
            <AuthorizedIcon
              action="add"
              model="travelhealthinsurance"
              popoverText={actionTypes.CANCEL}
              source={Variant99Black}
            />
          </Popconfirm>
        )}
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => record.id && handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="travelhealthinsurance"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="travelhealthinsurance"
          popoverText={actionTypes.CHANGE}
          source={PenToSquareSolidBlack}
          onClick={() => record?.id && handleOpenEditModal(record.id)}
        />
        <AuthorizedIcon
          action="view"
          model="travelhealthinsuranceadditionalfile"
          popoverText={actionTypes.ADDITIONAL_FILE}
          source={FolderOpenRegular}
          onClick={() =>
            handleSetAdditionalFile(record.id, record.additional_files)
          }
        />
      </Flex>
    ),
  },
];
